

























































































 
import { Component, Provide, Vue, Watch ,Prop } from "vue-property-decorator";
import { Provides } from '@/API/Tenant/Weixin';


@Component({
  components: {
  }
})

export default class extends Vue {
  @Prop() private propModuleData!:any;
  @Prop() private propPageinfo!:any;
  created(){
    // debugger
    console.log(this.propModuleData);
  }
  /** 子组件传值给父组件 */
  // selectedModule(){
  //   // debugger
  //   this.$emit('selectedModule',this.propModuleData)
  // }
}
